var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.243 29.758a1.99 1.99 0 0 1-1.414-.586c-3.119-3.119-8.194-3.12-11.314 0a2 2 0 1 1-2.828-2.828c4.679-4.68 12.292-4.679 16.97 0a2 2 0 0 1-1.414 3.414zM34.829 41.167c-3.073 0-6.146-1.17-8.485-3.509a2 2 0 1 1 2.828-2.828c3.119 3.119 8.194 3.12 11.314 0a2 2 0 1 1 2.828 2.828 11.966 11.966 0 0 1-8.485 3.509z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.899 38.243a2 2 0 0 1-1.414-3.414l11.172-11.172a2 2 0 1 1 2.828 2.828L43.313 37.657a1.99 1.99 0 0 1-1.414.586zM25.071 55.071a2 2 0 0 1-1.414-3.414l6.245-6.245a2 2 0 1 1 2.828 2.828l-6.245 6.245a1.99 1.99 0 0 1-1.414.586zM10.929 40.929a2 2 0 0 1-1.414-3.414l11.172-11.171a2 2 0 1 1 2.828 2.828L12.343 40.343c-.391.39-.903.586-1.414.586zM32.684 19.175a2 2 0 0 1-1.414-3.414l6.245-6.246a2 2 0 0 1 2.829 2.829l-6.245 6.246a2.003 2.003 0 0 1-1.415.585z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 57.935c-3.093 0-6.186-1.15-8.485-3.45-4.6-4.6-4.6-12.371 0-16.971a2 2 0 1 1 2.828 2.828c-3.066 3.066-3.066 8.248 0 11.314s8.248 3.066 11.314 0a2 2 0 1 1 2.828 2.828c-2.299 2.301-5.392 3.451-8.485 3.451zM53.071 27.071a2 2 0 0 1-1.414-3.414c3.066-3.066 3.066-8.248 0-11.314s-8.248-3.066-11.314 0a2 2 0 1 1-2.828-2.828c4.6-4.6 12.371-4.6 16.971 0s4.6 12.371 0 16.971c-.391.39-.903.585-1.415.585z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.bf1a7cd4fc884b5a4c2bcf118d4a5741.svg";
export { ForwardRef as ReactComponent };